<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">
                    Inscripciones
                </li>
                <li class="breadcrumb-item active li-actualizar-datos" aria-current="page" title="Actualizar datos" v-if="general.otros.app_modo=='online'" @click=obtener_recursos>
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">
                            <div style="width: 100%; display:flex; justify-content:space-evenly;">
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro>
                                    <i class='fa fa-plus' aria-hidden='true'></i>
                                    Nueva inscripción
                                </button>
                                <!-- <button type="button" class="boton-3d-success" @click=boton_modal_registro_bancos>                                    
                                    Bancos
                                </button> -->
                            </div>       
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <!-- inicio modal registro -->
        <div class="modal fade bd-example-modal-lg" id="modal-registro">
            <div class="modal-dialog modal-xl" style="width:90%">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        
                        <h5>
                            Inscripción
                        </h5>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">
                                 
                                <div class="form-group col-md-5">
                                    <label for="inputEmail4">Estudiante:</label> 
                                    <select class='form-control input-3d' v-model="datos.registro.estudiantes_id" @change="estudiante_seleccionado">
                                        <option value='' disabled>Seleccione</option>
                                        <option v-for='(estudiante,estudiante_index) in datos.estudiantes.todos' :key=estudiante_index :value=estudiante.id style="text-align:left;">
                                            {{ estudiante.matricula }}
                                            (
                                                {{ estudiante.nombre }}
                                                {{ estudiante.apellido_paterno }}
                                                {{ estudiante.apellido_materno }}
                                            )
                                        </option>
                                    </select>

                                    <template v-if="datos.registro.estudiantes_id!==''">
                                        <template v-for='(estudiante,estudiante_index) in datos.estudiantes.todos'>
                                            <label v-if="estudiante.id==datos.registro.estudiantes_id" :key="estudiante_index" style="margin-top:1em; font-size:1em;">
                                                <span style="font-weight:bold;">
                                                    Descuento del estudiante : 
                                                </span>
                                                {{ estudiante.descuento_porcentaje }} %
                                            </label>
                                        </template>
                                    </template>


                                </div> 

                                <div class="form-group col-md-7">
                                    <label for="inputEmail4">Oferta:</label> 
                                    <select class='form-control input-3d' v-model="datos.registro.educacion_ofertas_periodos_id" @change="oferta_seleccionado">
                                        <option value='' disabled>Seleccione</option>                                        
                                        <option v-for='(oferta,oferta_index) in datos.ofertas.todos' :key=oferta_index :value=oferta.educacion_ofertas_periodos_id>
                                            {{ oferta.estudio_nombre }}
                                            {{ oferta.periodo_nombre }}
                                        </option>                                      
                                    </select>

                                    <template v-if="datos.registro.educacion_ofertas_periodos_id!==''">
                                        <template v-for='(oferta,oferta_index) in datos.ofertas.todos'>
                                            <label v-if="oferta.educacion_ofertas_periodos_id==datos.registro.educacion_ofertas_periodos_id" :key="oferta_index" style="margin-top:1em; font-size:1em;">
                                                <span style="font-weight:bold;">
                                                    Costo : 
                                                </span>
                                                 {{ general_formato_moneda( oferta.costo ) }}
                                            </label>
                                        </template>
                                    </template>
                                    <br>
                                    <label for="" v-if="datos.registro.costo_final!==''">
                                        <span style="font-weight:bold;">
                                            Costo final : 
                                        </span>
                                        {{ general_formato_moneda(datos.registro.costo_final) }} 
                                    </label>

                                </div> 
                                
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Semestre:</label> 
                                    <select class="form-control" v-model="datos.registro.semestre">
                                        <option value="" disabled>Seleccione</option>
                                        <option value="1">1er Semestre</option>
                                        <option value="2">2do Semestre</option>
                                        <option value="3">3er Semestre</option>
                                        <option value="4">4to Semestre</option>
                                        <option value="5">5to Semestre</option>
                                        <option value="6">6to Semestre</option>
                                    </select>
                                    <!---<input type="number" class="form-control input-3d" v-model="datos.registro.semestre">-->
                                </div> 

                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Grupo:</label> 
                                    <!-- <input type="text" class="form-control input-3d" v-model="datos.registro.grupo"> -->
                                     <select class="form-control" v-model="datos.registro.grupo">
                                        <option value="" disabled>Seleccione</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                    </select>
                                </div>
                                
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Forma de pago:</label> 
                                    <select class='form-control input-3d' v-model="datos.registro.forma_pago">
                                        <option value='' disabled>Seleccione</option>
                                        <!-- <option value="deposito">Deposito</option> -->
                                        <option value="transferencia_deposito">Transferencia/Deposito</option>
                                        <option value='efectivo'>Efectivo</option>
                                    </select>
                                </div>

                                <div class="form-group col-md-12" v-if="datos.registro.forma_pago=='transferencia_deposito'">
                                    <label for="inputEmail4">Comprobante:</label> 
                                    <input type="file" accept=".pdf" class="form-control input-3d" id="registro_comprobante" @input="comprobante_seleccionado">                                    
                                    <div v-if="datos.registro.comprobante.url!==''">
                                        <iframe :src=datos.registro.comprobante.url style="width:75%; height:400px;" frameborder="0"></iframe>                                                   
                                    </div>
                                </div>
                                
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer">
                        
                        <template v-if="datos.registro.etapa!=='finalizado'"> 

                            <!-- <button v-if="datos.registro.id!==''" type="button" class="boton-3d-success" @click="enviar_datos_finalizar">
                                Finalizar
                            </button> -->

                            <button type="button" class="boton-3d-success" @click="enviar_datos">
                                Guardar
                            </button>                            
                        </template>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">
                            Cerrar
                        </button>

                    </div>

                </div>
            </div>
        </div>
        <!---fin modal registro---->    
        
        
        <!-- inicio modal_comprobante -->
        <div class="modal fade bd-example-modal-lg" id="modal_comprobante">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        
                        <h5>
                            Comprobante del registro id: {{datos.registro.id}}
                        </h5>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <!-- <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div> -->
                            <div class="form-row">                                                                                                  
                                
                                <div class="form-group col-md-12">
                                    <label for="inputEmail4">Comprobante:</label> 
                                    <div v-if="datos.registro.comprobante.url!==''">
                                        <iframe :src=datos.registro.comprobante.url style="width:75%; height:400px;" frameborder="0"></iframe>                                                   
                                    </div>
                                </div>                                                                                                
                                
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer">
                                                
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">
                            Cerrar
                        </button>

                    </div>

                </div>
            </div>
        </div>
        <!---fin modal_comprobante---->


    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
//import { mapMutations } from 'vuex'

import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                id:'',
                estudiantes_id:'',
                educacion_ofertas_periodos_id:'',
                semestre:'',
                grupo:'',
                forma_pago:'',id:'',
                estudiantes_id:'',
                educacion_ofertas_periodos_id:'',
                semestre:'',
                grupo:'',
                forma_pago:'',
                comprobante:{
                    archivo:'',
                    url:''
                },

                costo:'',
                descuento_porcentaje:'',
                descuento_cantidad:'',

                costo_final:'',
                etapa:''
            },
            estudiantes:{
                todos:[]
            },
            ofertas:{
                todos:[]
            },
            data_table:{
                cargando:false,
                registros:[]
            }
        }
    }
    },
    mounted(){
        /* let a=this.fecha_hoy;
        console.log('fecha 2 de hoy es');
        console.log(a); */

        //console.log('moneda es');
        //console.log(this.formato_moneda(5));
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        //...mapActions(['formato_moneda']),
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                this.obtener_recursos();
                //this.data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        },  
        obtener_recursos()
        {
            this.data_table();
            fetch(`${this.general.otros.dominio_server}/inscripciones/recursos`,{   
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                this.datos.estudiantes.todos=respuesta.datos.estudiantes;
                this.datos.ofertas.todos    =respuesta.datos.ofertas;
                //this.datos.bancos.todos=respuesta.datos.bancos;

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },    
        boton_modal_registro()
        {
            for (const p in this.datos.registro) {                    
                                
                if(p=='comprobante')
                {
                    this.datos.registro[p].archivo='';
                    this.datos.registro[p].url='';
                }
                else
                {
                    this.datos.registro[p]='';                
                }
                
            }                             

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
        },
        data_table()
        {
            this.datos.data_table.cargando=true;            
            fetch(`${this.general.otros.dominio_server}/inscripciones/todos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                
                this.datos.data_table.registros=respuesta.datos;                
                this.data_table_crear();
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los datos`});
            })
            .finally( () => {
                this.datos.data_table.cargando=false;                
            });
        },
        data_table_crear()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th style="width:10%;">Id</th>
                            <th>Estudiante</th>
                            <th>Oferta</th>
                            <th>Forma pago</th>
                            <th>Etapa</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Id</th>
                            <th>Estudiante</th>
                            <th>Oferta</th>
                            <th>Forma pago</th>
                            <th>Etapa</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'desc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, "data":function(data,type,full,meta)
                        {
                            return data.id;
                        }
                    }, 
                    {"targets":1, "data":function(data,type,full,meta)
                        {                                                        
                            return `
                                ${data.nombre} ${data.apellido_paterno} ${data.apellido_materno}
                            `;
                        }
                    }, 
                    {"targets":2, "data":function(data,type,full,meta)
                        {                                                        
                            return data.oferta;                                
                        }
                    }, 
                    {"targets":3, "data":function(data,type,full,meta)
                        {                                                        
                            return data.forma_pago;                                
                        }
                    }, 
                    {"targets":4, "data":function(data,type,full,meta)
                        {                                                        
                            return data.etapa;                                
                        }
                    }, 
                    {"targets":5, "data":(data,type,full,meta)=>
                        {
                            let acciones=``;                            

                            acciones+=`
                                <button registro-id='${data.id}' class="boton_modal_editar_registro boton-3d-info" style="margin-right:1em;">                                    
                                    <i registro-id='${data.id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>                                    
                                </button>
                                <button registro-id='${data.id}' class="boton_modal_remover_registro boton-3d-danger" style="margin-right:1em;">
                                    <i registro-id='${data.id}' class='fa fa-times' aria-hidden='true'></i>                                    
                                </button>
                            `;

                            if(data.forma_pago=='efectivo')
                            {
                                if(data.etapa=='inicio')
                                {
                                    acciones+=`
                                        <button registro-id='${data.id}' class="boton_modal_finalizar_registro boton-3d-success" style="margin-right:1em;">
                                            Finalizar
                                        </button>
                                    `;
                                }
                            }                    
                            else if(data.forma_pago=='transferencia_deposito')
                            {
                                acciones+=`
                                    <button registro-id='${data.id}' class="boton_modal_comprobante boton-3d-info" style="margin-right:1em;">
                                        comprobante                                        
                                    </button>
                                `;     

                                if(data.etapa=='verificacion')
                                {   
                                    acciones+=`
                                        <button registro-id='${data.id}' class="boton_modal_finalizar_registro boton-3d-success" style="margin-right:1em;">
                                            Finalizar
                                        </button>
                                    `;
                                }
                            }

                            if(data.etapa=='finalizado')
                            {
                                acciones+=`
                                    <a class="boton-3d-info" target="_blank" href="${this.general.otros.dominio_server}/publico/inscripciones/${data.clave_unica}/formato1" style="margin-right:1em;">
                                        Recibo
                                    </a>
                                `;
                            }

                            return `
                                <div style="display:flex; justify-content:left; align-items:center;">
                                    ${acciones} 
                                </div>
                            `;
                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton_modal_editar_registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });

            Array.from(document.getElementsByClassName("boton_modal_remover_registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover_registro);
            });

            Array.from(document.getElementsByClassName("boton_modal_finalizar_registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_finalizar_registro);
            });

            Array.from(document.getElementsByClassName("boton_modal_comprobante")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_comprobante);
            });
        },
        boton_modal_comprobante(item)
        {
            this.datos.registro.id=calculos.atributo(item,'registro-id');
            this.datos.registro.comprobante.url=`${this.general.otros.dominio_server}/inscripciones/${this.datos.registro.id}/comprobante`;            

            console.log('datos');
            console.log(this.datos.registro);
            //this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal_comprobante").modal('show');
        },
        boton_modal_finalizar_registro(item)
        {
            this.datos.registro.id=calculos.atributo(item,'registro-id');
            Swal.fire({
                title: `¿ Finalizar registro id : ${this.datos.registro.id} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, finalizar ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) 
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/inscripciones/registro/finalizar`,{
                        method:'POST',
                        body:JSON.stringify( {
                            id:this.datos.registro.id
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    //.then(res=>res.json())
                    .then(res => {
                        if (res.status == 200) 
                        {
                            return res.json();
                        }
                        else
                        {
                            throw new Error(`Error: ${res.status}`);
                        }
                    })
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                //this.data_table();
                                //$("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Registro finalizado`});
                            },
                            'no_verificacion':()=>{
                                this.funciones({nombre:'alerta',estatus:'error',mensaje:``});
                            },
                            'no_forma_pago':()=>{
                                this.funciones({nombre:'alerta',estatus:'error',mensaje:``});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo finalizar`});
                    })
                    .finally( () => {
                        this.data_table();
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_remover_registro(item)
        {
            //this.datos.registro.i            
            this.datos.registro.id=calculos.atributo(item,'registro-id');
            Swal.fire({
                title: `¿ Remover registro id : ${this.datos.registro.id} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, remover ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) 
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/inscripciones/registro/remover`,{
                        method:'POST',
                        body:JSON.stringify( {
                            id:this.datos.registro.id
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    //.then(res=>res.json())
                    .then(res => {
                        if (res.status == 200) 
                        {
                            return res.json();
                        }
                        else
                        {
                            throw new Error(`Error: ${res.status}`);
                        }
                    })
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                //this.data_table();
                                //$("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Registro removido`});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo remover`});
                    })
                    .finally( () => {
                        this.data_table();
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_editar_registro_evento(item)
        {        
            this.boton_modal_registro();
            this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;        
            //fetch(`${this.general.otros.dominio}/productos/${this.datos.registro.id}/datos`)
            fetch(`${this.general.otros.dominio_server}/inscripciones/${this.datos.registro.id}/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{

                if(respuesta.datos.registro.length>0)
                {
                    let c=respuesta.datos.registro[0];
                    let r=this.datos.registro;                   

                    r.estudiantes_id                =c.estudiantes_id;
                    r.educacion_ofertas_periodos_id =c.educacion_ofertas_periodos_id;
                    r.semestre                      =c.semestre;
                    r.grupo                         =c.grupo;
                    r.forma_pago                    =c.forma_pago;
                    r.comprobante.url   =`${this.general.otros.dominio_server}/inscripciones/${this.datos.registro.id}/comprobante`;
                    r.costo_final       =c.costo_final;
                    r.etapa             =c.etapa;
                }

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo obtener la información`});
            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            
        },                     
        
        enviar_datos(a)
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'}); 

            let formdata=new FormData();             

            formdata.append('id'            ,this.datos.registro.id);
            formdata.append('estudiantes_id',this.datos.registro.estudiantes_id);
            formdata.append('educacion_ofertas_periodos_id',    this.datos.registro.educacion_ofertas_periodos_id);
            formdata.append('semestre'      ,this.datos.registro.semestre);
            formdata.append('grupo'         ,this.datos.registro.grupo);
            formdata.append('forma_pago'    ,this.datos.registro.forma_pago);
            formdata.append('comprobante'   ,this.datos.registro.comprobante.archivo);

            formdata.append('costo',this.datos.registro.costo);
            formdata.append('descuento_porcentaje',this.datos.registro.descuento_porcentaje);
            formdata.append('descuento_cantidad',this.datos.registro.descuento_cantidad);

            formdata.append('costo_final'   ,this.datos.registro.costo_final);


            fetch(`${this.general.otros.dominio_server}/inscripciones/registro`,{
                method:'POST',                
                //body:JSON.stringify(this.datos.registro),
                body:formdata,
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    //'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        //this.data_table();
                        $("#modal-registro").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Guardado`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo guardar`});
            })
            .finally( () => {
                this.data_table();
                //this.datos.data_table.cargando=false;
            });
        },
        enviar_datos_finalizar(a)
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'}); 

            let formdata=new FormData();             

            formdata.append('id'            ,this.datos.registro.id);
            /* formdata.append('estudiantes_id',this.datos.registro.estudiantes_id);
            formdata.append('educacion_ofertas_periodos_id',    this.datos.registro.educacion_ofertas_periodos_id);
            formdata.append('semestre'      ,this.datos.registro.semestre);
            formdata.append('grupo'         ,this.datos.registro.grupo);
            formdata.append('forma_pago'    ,this.datos.registro.forma_pago);
            formdata.append('comprobante'   ,this.datos.registro.comprobante.archivo); */

            fetch(`${this.general.otros.dominio_server}/inscripciones/registro/finalizar`,{
                method:'POST',                
                //body:JSON.stringify(this.datos.registro),
                body:formdata,
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    //'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        //this.data_table();
                        $("#modal-registro").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Finalizado`});
                    },
                    'falta_comprobante':()=>{                        
                        //this.data_table();
                        //$("#modal-registro").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`Falta comprobante`});
                    },
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo guardar`});
            })
            .finally( () => {
                this.data_table();
                //this.datos.data_table.cargando=false;
            });
        },
        comprobante_seleccionado()
        {
            this.funciones({
                nombre:'cargar_archivo',
                elemento_html:'registro_comprobante',
                destino:this.datos.registro.comprobante
            });   
        },
        estudiante_seleccionado()
        {
            this.calcular_costo_final();
        },
        oferta_seleccionado()
        {
            this.calcular_costo_final();
        },
        calcular_costo_final()
        {
            this.datos.registro.costo_final='';
            let est=this.datos.estudiantes.todos.find((e)=>e.id==this.datos.registro.estudiantes_id);
            let ofe=this.datos.ofertas.todos.find((e)=>e.educacion_ofertas_periodos_id==this.datos.registro.educacion_ofertas_periodos_id);

            if(est!==undefined && ofe!==undefined)
            {
                this.datos.registro.costo=ofe.costo;
                this.datos.registro.descuento_porcentaje=est.descuento_porcentaje;
                this.datos.registro.descuento_cantidad=calculos.calcular_multiplicacion([
                    calculos.calcular_divicion([
                        ofe.costo,100
                    ]),
                    est.descuento_porcentaje
                ]);

                this.datos.registro.costo_final=
                calculos.calcular_resta([
                    ofe.costo,
                    this.datos.registro.descuento_cantidad
                    /* calculos.calcular_multiplicacion([
                        calculos.calcular_divicion([
                            ofe.costo,100
                        ]),
                        est.descuento_porcentaje
                    ]) */
                ]);

            }
        }
    },
    computed: {
        ...mapState(['general']),
        ...mapGetters([
            'general_fecha_hoy',
            'general_no_xss',
            'general_formato_moneda'
        ]),
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }
    #modal_movimientos{
        #contenedor_img_bancos{
            height:100%;
            display:flex;
            align-items:center;
            img{
                width:150px;
            }
        }
        #contenedor_tabla_ultimos_movimientos{
            height:300px; 
            overflow:scroll;

            .fecha_creacion{
                font-size:0.8em;
                font-weight:bold;
                margin:0px;
            }
            .hora_creacion{
                font-size:0.8em;
                font-weight:bold;
            }
            .descripcion{
                font-size:1em;
                margin:0px;
            }
            .contenedor-cantidad-remover{
                display:flex;
                flex-wrap:wrap;
                justify-content:right;
                height:100px;
                align-content:space-between;
                .cantidad{
                    font-size:1.5em;
                    width:100%;
                    text-align:right;
                }
            }
            .cantidad_restar{
                color:red;
            }
            
        }
    }
    
</style>